const React = require("react");
const withState = require("../../../../../../utils/withState");

const {WALLETS_DATA, WALLET_TYPES} = require('../../../../../../constants/wallets');

const SelectWalletField = require('./components/SelectWalletField');
const SelectWalletDropdown = require('./components/SelectWalletDropdown');

module.exports = withState((setState) => {

  const ref = React.createRef();

  return (state, props) => {
    const togglePopup = () => setState({open: !state.open});

    return (
      <div className={"layoutRow fhaS fvaC w" + (props.className ? ` ${props.className}` : '')}>
        <div
          className="c8B8D93 f14 fw5 w(|min)90 pr10 ff$2 __label"
        >{props.label}</div>
        <div id="walletSelector" ref={ref} className="w rlv">
          <SelectWalletField value={(WALLETS_DATA[props.value] || {}).name} open={state.open} error={props.error} onClick={togglePopup} />
          <SelectWalletDropdown open={state.open} anchorEl={(ref || {}).current} onChange={props.onChange} onClose={togglePopup} />
          {
            props.error ? (
              <div
                className="abs sh20 sb xY100% f12 cEC4C4C fw4"
              >{props.helperText || 'Obligatory field'}</div>
            ) : null
          }
        </div>
      </div>
    )
  }
})
